export const SITE_LINKS = {
  home: '/',
  products: '#products',
  about: '#about',
  contact: '#contact',
  email: 'mailto:2531295160@qq.com',
  github: 'https://github.com/zzb2001',
} as const;

export const PRODUCT_LINKS = {
  acebook: 'https://banposter.acebook.online/',
  aiguide: 'https://ai.acebook.online/',
} as const;
